import { createContext } from 'react';

import { Shop, ShopGroup, User } from 'types';

export type PayoutOrdersContextProps = {
  shops?: Shop[];
  shopGroups?: ShopGroup[];
  traders?: User[];
  merchants?: User[];
};

export const PayoutOrdersContext = createContext<PayoutOrdersContextProps>({
  shops: [],
  shopGroups: [],
  traders: [],
  merchants: [],
});
